/**
 * Schermteksten in het Frans.
 *
 * GEMAAKT DOOR EEN MACHINE uit teksten/nl.ts, met
 * server/scripts/vertaal-teksten.ts. Niet met de hand bijwerken: een
 * volgende ronde overschrijft het.
 *
 * Machinevertaling van een interface is een START. Knoppen zijn kort en
 * zonder context, en juist daar gaat het mis. Laat dit nakijken door
 * iemand die de taal spreekt voordat het naar echte gebruikers gaat.
 */
import type { Teksten } from './nl';

export const fr: Teksten = {
  kamerOphalen: "Récupération de la pièce…",
  kamerWerktNiet: "Cette pièce ne fonctionne pas",
  serverReageertNiet: "Le serveur ne répond pas",
  probeerOpnieuw: "Réessaie",
  vraagNieuweCode: "Demande un nouveau code à la personne qui l'a partagé. Une pièce expire après quelques heures.",
  welkeTaalSprekJij: "Quelle langue parles-tu ?",
  jouwStem: "Ta voix dans la traduction",
  man: "Homme",
  vrouw: "Femme",
  pincode: "Code PIN",
  pincodeUitleg: "Tu le reçois de la personne qui a partagé le code.",
  gaDeKamerIn: "Entre dans la pièce",
  kiesEerstJeTaal: "Choisis d'abord ta langue",
  microfoonAanvragen: "Demande de micro…",
  toestemmingUitleg: "Ton navigateur va te demander l'autorisation d'utiliser le micro. Sans cela, tu ne pourras qu'écrire.",
  microfoonTestLink: "Teste d'abord ton micro",
  stemGaatMee: "Dans cette pièce, l'autre entend aussi ta propre voix, en plus de la traduction.",
  alleenChatMelding: "Cette conversation est en chat uniquement. Tu tapes tes messages et lis la traduction ; rien n'est lu à voix haute.",
  verlooptOm: "Expire à",
  nooitVasteKamer: "Jamais, salle permanente",
  kamer: "Pièce",
  tolkgesprek: "Interprétation",
  juisteKamer: "Tu es dans la bonne pièce. Tu pourras bientôt participer à la conversation.",
  jij: "toi",
  deAnder: "l'autre",
  verbinden: "Connexion…",
  verbonden: "Connecté",
  verbindingKwijt: "Connexion perdue. Nouvel essai…",
  wachtenOpAnder: "Tu es entré. En attente que l'autre scanne le QR-code.",
  allebeiInDeKamer: "Vous êtes tous les deux dans la pièce.",
  anderIsWeg: "L'autre est parti",
  anderSpreekt: "L'autre parle…",
  jeKuntErNietIn: "Tu ne peux pas entrer",
  overgenomenTitel: "Poursuivi sur un autre appareil",
  overgenomenUitleg: "Cette conversation vient d'être ouverte sur un autre appareil. Tu continues là-bas.",
  terug: "Retour",
  geluidStaatUit: "Le son est coupé. Tapote n'importe où sur l'écran.",
  tikHier: "tapote ici",
  bewaardTot: 'Conservé jusqu\'à {tijd}',
  bewaardVast: "Salle permanente. Les messages sont conservés 30 jours.",
  spreekIn: "Parle",
  luisteren: "Écoute… tapote pour arrêter",
  uitschrijven: "Transcription…",
  tijdOmTeVerbeteren: "Temps pour corriger",
  altijdZelfVersturen: "Toujours vérifier et envoyer soi-même",
  jijVerstuurtZelf: "Tu envoies toi-même",
  uit: "désactivé",
  sec: "sec",
  vertalingMeteenAfspelen: "Lire la traduction immédiatement",
  typHierJeBericht: "Écris ton message ici…",
  stuur: "Envoie",
  geenOpnameMogelijk: "Ce navigateur ne peut pas enregistrer d'audio. Le clavier fonctionne.",
  verstaanAls: "Compris comme",
  tellerStaatStil: "compteur arrêté",
  versturen: "Envoyer",
  wis: "Efface",
  jijZei: "tu as dit",
  vertaald: "traduit",
  duimOmhoog: "C'est correct",
  duimOmlaag: "Ce n'est pas correct",
  opnieuwProberenKnop: "Réessayer avec un meilleur modèle",
  opnieuwProberenBezig: "Traduction en cours…",
  duimTranscriptWoordenlijstUitnodiging: "Mal compris ? Corrige-le dans le glossaire :",
  instellingenAanpassen: "Modifier les paramètres",
  geldtVoorJullieBeiden: "S'applique à vous deux",
  alleenVoorJou: "Uniquement pour toi",
  stuurMijnStemMee: "Envoyer ma propre voix",
  verbeterSpelfouten: "Corriger les fautes d'orthographe dans mon texte",
  verbeterSpelfoutenUit: "Désactiver affiche ce qui a été réellement compris, erreurs comprises.",
  alleenChat: "Chat uniquement : pas de voix, pas de micro",
  alleenChatUitleg: "Vous tapez tous les deux. La traduction et le texte original s'affichent ; rien n'est lu à voix haute.",
  aangepastDoorDeAnder: "L'autre a modifié les paramètres.",
  foutSpraak: "La traduction est disponible, mais aucun son n'a été émis.",
  foutSpraakQuota: "Le quota vocal du jour est épuisé. Le texte continue de fonctionner ; la voix reviendra demain.",
  foutBudgetKamer: "Cette conversation a atteint sa limite, la traduction est donc en pause. La personne qui l’a créée peut l’augmenter ; ensuite, tout refonctionne aussitôt.",
  foutBudgetMaand: "Le budget mensuel de l’application est épuisé. La traduction reprendra dès que l’administrateur l’aura ajusté.",
  foutTaal: "Cette langue est impossible : vous parleriez tous les deux la même.",
  origineel: "original",
  vertalen: "Traduction…",
  vertalenMislukt: "Échec de la traduction.",
  opnieuwAfspelen: "Rejouer la traduction",
  hoorDeAnder: "Écoute comment l'autre l'a dit lui-même",
  woordenlijst: "Glossaire de secours",
  woordenlijstUitleg: "L'appli comprend mal un nom ou un terme technique ? Définis ici ce qui est attendu.",
  hijHoort: "il entend…",
  jijBedoelt: "tu veux dire…",
  ookVolgendeGesprekken: "Aussi pour les prochains échanges — sinon ne s'applique qu'ici",
  voegToe: "Ajoute",
  bezig: "En cours…",
  lijstNietGeladen: "La liste n'a pas pu être chargée.",
  toevoegenMislukt: "Échec de l'ajout.",
  verwijderenMislukt: "Échec de la suppression.",
  overal: "partout",
  verwijder: "Supprime",
  overDitGesprek: "Over dit gesprek",
  toon: "Ton de la traduction",
  sfeer: "Ambiance de l'échange",
  jouwPlek: "Ta place",
  hoeHetWerkt: "Le serveur transcrit ton enregistrement et le traduit d'un coup. Ta propre voix accompagne la traduction.",
  kleinereTekst: "Texte plus petit",
  grotereTekst: "Texte plus grand",
  insprekenVerbergen: "Masquer la dictée",
  insprekenTonen: "Afficher la dictée",
  toetsenbordVerbergen: "Masquer le clavier",
  toetsenbordTonen: "Afficher le clavier",
  vormAutomatisch: "Automatique",
  vormInformeel: "Tu (tutoiement)",
  vormFormeel: "Vous (vouvoiement)",
  sfeerNeutraal: "Neutre",
  sfeerZakelijk: "Professionnelle",
  sfeerOfficieel: "Officielle",
  sfeerVriendschappelijk: "Amicale",
  sfeerPartner: "Partenaire",
  foutKamerVol: "Cette pièce est pleine. Deux personnes maximum peuvent y entrer.",
  plekBezetTitel: "Ta place est prise",
  plekBezetUitleg: "Quelqu'un occupe déjà ton côté de cette conversation, dans ta langue. Le plus souvent, c'est toi : la conversation est encore ouverte sur un autre appareil ou dans un autre onglet. Ferme-la là-bas et réessaie. Il faut parfois une minute et demie pour que la place se libère.",
  plekBezetWissel: "C'est toi ? Tape WISSEL pour faire passer la conversation sur cet appareil. L'autre appareil se fermera.",
  plekBezetKnop: "Passer sur cet appareil",
  foutKamerVerlopen: "Cette pièce a expiré ou est fermée.",
  foutKamerOnbekend: "Cette pièce n'existe pas.",
  foutPinNodig: "Cette pièce nécessite un code PIN.",
  foutPinFout: "Ce code PIN est incorrect.",
  foutProtocol: "L'appli et le serveur ne se comprennent pas. Actualise la page.",
  foutMicroGeweigerd: "Tu as refusé l'accès au micro. Clique sur le cadenas dans la barre d'adresse pour l'activer.",
  foutGeenMicro: "Aucun micro n'a été trouvé. Branche-en un et réessaie.",
  foutMicroInGebruik: "Le micro est utilisé par une autre application. Ferme-la et réessaie.",
  foutGeenHttps: "Le micro ne fonctionne que sur une connexion sécurisée. Ouvre cette page en https.",
  foutMicroOnbekend: "Impossible de démarrer le micro.",
  foutNietsOpgenomen: "Rien n'a été enregistré. Ton micro est-il activé ?",
  foutNietsGehoord: "Rien entendu. Ton micro est-il activé et parles-tu assez fort ?",
  foutOpnameTeLang: "Cet enregistrement est trop long. Parle par séquences plus courtes.",
  foutMicroGedempt: "Ton micro est coupé. Active-le et réessaie.",

  // --- microfoontest ---
  micTitel: "Test du micro",
  micOnderschrift: "Quatre tests à la suite, cinq secondes chacun. Continue à parler tout du long.",
  micStart: "Lancer le test",
  micTest1: "1. Reconnaissance seule",
  micTest2: "2. Enregistrement seul",
  micTest3: "3. Ensemble — enregistrement d'abord",
  micTest4: "4. Ensemble — reconnaissance d'abord",
  micFase1: "1 sur 4 : reconnaissance seule — dis une phrase courte",
  micFase2: "2 sur 4 : enregistrement seul — continue à parler",
  micFase3: "3 sur 4 : enregistrement d'abord, puis reconnaissance — continue à parler",
  micFase4: "4 sur 4 : reconnaissance d'abord, puis enregistrement — continue à parler",
  micKlaar: "terminé",
  micGehoord: "entendu",
  micOpnameformaat: "Format d'enregistrement",
  micGeen: "aucun",
  micBeveiligd: "Connexion sécurisée",
  micJa: "oui",
  micNee: "NON",
  micBrowser: "Navigateur",
  micGeenHttps: "Sans https, le navigateur ne libère pas le micro. Sur localhost, c'est permis.",
  micGeenHerkenning: "Ce navigateur ne connaît pas la reconnaissance vocale.",
  micZegIets: "dis quelque chose…",
  micWoordenBinnen: "des mots arrivent",
  micKonNietStarten: "n'a pas pu démarrer",
  micGeenRecorder: "Ce navigateur ne connaît pas MediaRecorder.",
  micOpnemen: "enregistrement…",
  micNietsOpgenomen: "rien enregistré",
  micGeenMicrofoon: "pas de micro",
  micOpnameEerst: "enregistrement d'abord…",
  micHerkenningEerst: "reconnaissance d'abord…",
  micOpnameStarttNiet: "l'enregistrement n'a pas démarré",
  micSamenGelukt: "Ensemble. Enregistrement {kb} kB.",
  micAlleenOpname: "Enregistrement oui, reconnaissance non.",
  micAlleenHerkenning: "Reconnaissance oui, enregistrement non.",
  micGeenVanBeide: "Ni l'un ni l'autre.",
  micNetwerkFout: "La reconnaissance vocale n'a pas pu joindre le serveur.",
  micAfgebroken: "L'enregistrement a été interrompu.",
  verslagTitel: "Compte rendu de conversation",
  verslagWie: "Qui",
  verslagOrigineel: "Original",
  verslagVertaling: "Traduction",
  verslagSpreker: "Interlocuteur {x}",
  verslagBerichten: "Messages",
  verslagGemaaktOp: "Créé le",
  verslagGeenOpname: "Pas un enregistrement mot à mot.",
  verslagNootOrigineel: "« Original » est le texte tel que l’application a compris la personne qui parlait.",
  verslagNootCorrectie: "La correction orthographique était activée : les petites fautes de frappe ont été corrigées.",
  verslagNootAangepast: "La personne qui parlait pouvait encore modifier le texte avant l’envoi.",
  verslagGesproken: "parlé",
  verslagGetypt: "tapé",
  verslagMislukt: "Échec de la traduction. L’autre personne n’a pas vu cette phrase dans sa langue.",
  verslagNietKlaar: "La traduction n’était pas encore prête lorsque ce compte rendu a été créé.",
  verslagVertrouwelijk: "Confidentiel.",
  verslagAlleenDeelnemers: "Ce compte rendu contient le contenu d’une conversation privée et est destiné uniquement aux participants.",
  verslagGewist: "Date de suppression de la conversation : {tijd}. Ensuite, ce compte rendu ne pourra plus être recréé.",
  verslagGewistVast: "Salle permanente : chaque message est supprimé 30 jours après son envoi. Les messages plus anciens ne figurent pas dans ce compte rendu.",
};
